module.exports = __webpack_public_path__ + "img/Molluscs.3bd2976f.png";